import axios from 'axios';

import { INotary } from '@/shared/model/notary.model';

const baseApiUrl = 'api/notaries';

export default class NotaryService {
  public find(id: number): Promise<INotary> {
    return new Promise<INotary>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          if (err.response.status === 404) {
            resolve(null);
          } else {
            reject(err);
          }
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(notaryId: number, entity: INotary): Promise<INotary> {
    return new Promise<INotary>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${notaryId}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public create(entity: INotary): Promise<INotary> {
    return new Promise<INotary>((resolve, reject) => {
      axios
        .post(baseApiUrl, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
